export default {
    // nome app
    "SalesPaddy":"SalesPaddy",
    // tabs
    "Home":"Home",
    "Salons":"Salons",
    "Users":"Users",
    "Dealers":"Dealers",
    "Digital Inventory":"Digital Inventory",
    // filtro nelle tabelle
    "Applica filtro":"Filter anwenden",
    "filtro...":"Filter...",
    // azioni salon
    "Crea":"Anlegen",
    // salons: tabella e form
    "Ragione Sociale":"Firmenbezeichnung",
    "Insegna":"Geschäftsbezeichnung",
    "Autocomplete":"Autovervollständigen",
    "Indirizzo":"Addresse",
    "Città":"Stadt",
    "Cap":"Postleitzahl",
    "Paese":"Bundesland",
    "Provincia":"Gelände",
    "Nazione":"Staat",
    "Email":"Email",
    "Telefono":"Telefonnummer",
    "Web":"Web",
    "Attivo":"Aktiv",
    "Alert":"Alert",
    "Tipo":"Typ",
    "Latitude":"Breite",
    "Longitude":"Längengrad",
    "Latitude2":"Breite2",
    "Longitude2":"Längengrad2",
    // sezioni form
    "Dati principali":"Stammdaten",
    "Sede Legale":"Geschäftssitz",
    "Contatto":"Kontakt",
    "Dati qualitativi":"Qualitative Daten",
    // users: tabella e form
    "Dealer":"Dealer",
    "Codice X3":"ERP Code",
    "Nome":"Name",
    "Cognome":"Familienname",
    "Lingua":"Sprache",
    "Privilegi":"Vorrechte",
    // sezioni form
    "Dati Anagrafici":"Personenangaben",
    //
    "Codice Dealer":"Dealer Code",
    "Inserire il codice":"Code einsetzen",
    "Codice Dealer non trovato":"Dealer Code nicht gefunden",
    // mappa
    "Mappa Saloni":"Salonsskarte",
    "Saloni visualizzati:":"Salons gezeigt:",
    "Leads":"Leads",
    "Saloni":"Salons",
    "Tipo Visualizzazione:":"Art der Visualisierung",
    "Heatmap":"Heatmap",
    "Markers":"Markers",
    "Scheda Lead":"Lead Info",
    "Scheda Cliente":"Salon Info",
    "Google Maps":"Google Maps",
    "Risultato ricerca:":"Suchergebnisse:",
    "Corrispondenze trovate:":"Treffer gefunden:",
    "Valutazione:":"Bewertungen:",
    "Recensioni:":"Bewertungen:",
    "x":"x",
}